import { InformationSlabCircleOutlineIcon } from './InformationSlabCircleOutlineIcon';

/**
 * author: Jeff Anders
 * id 0A06A44E-09F4-491E-B221-24E401CA3DDB
 * name information-slab-circle-outline
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/information-slab-circle-outline.svg
 * tags
 * - Settings 
 */
export const InfoSlabCircleOutlineIcon = InformationSlabCircleOutlineIcon;
export default InfoSlabCircleOutlineIcon